<template>
  <section class="containerGeralAccounting">
    <div class="customCard">
      <span class="title">
        <b-icon-calculator-fill class="icons" />
        <p>CONTABILIDADE</p>
      </span>

      <div class="rowCustomAccounting">
        <span class="contentInputAccounting">
          <Input
            label="Nome Contabilidade"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.nome"
            :isDisabled="isDisabledInputs"
            ref="nome"
          />
        </span>

        <span class="contentInputAccounting">
          <InputCnpj
            label="CNPJ Contabilidade"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.cnpj"
            :mask="dataAccounting.cnpj"
            :isDisabled="isDisabledInputs"
            ref="cnpj"
          />
        </span>

        <span
          class="contentInputAccounting"
          style="width: 30%; min-width: 130px"
        >
          <InputPhone
            label="Telefone"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.telefone"
            :mask="dataAccounting.telefone"
            :isDisabled="isDisabledInputs"
            ref="telefone"
          />
        </span>
      </div>

      <div class="rowCustomAccounting">
        <span class="contentInputAccounting" style="width: 40%">
          <InputCep
            label="CEP"
            type="text"
            showBtnCep
            isMaskCep
            :labelFixed="true"
            :dataInput.sync="dataAccounting.cep"
            :mask="dataAccounting.cep"
            :isDisabled="isDisabledInputs"
            :maxlength="9"
            :clickBtnCep="() => handleCep(dataAccounting.cep)"
            ref="cep"
          />
        </span>

        <span class="contentInputAccounting">
          <Input
            label="Endereço"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.endereco"
            :isDisabled="isDisabledInputs"
            ref="endereco"
          />
        </span>

        <span class="contentInputAccounting">
          <Input
            label="Bairro"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.bairro"
            :isDisabled="isDisabledInputs"
            ref="bairro"
          />
        </span>

        <span class="contentInputAccounting" style="width: 30%">
          <Input
            label="Nº"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.numero"
            :isDisabled="isDisabledInputs"
            ref="numero"
          />
        </span>
      </div>

      <div class="rowCustomAccounting">
        <span class="contentInputAccounting">
          <Input
            label="Responsável"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.responsavel"
            :isDisabled="isDisabledInputs"
            ref="responsavel"
          />
        </span>
        <span class="contentInputAccounting">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataAccounting.cpf"
              v-mask="maskCpf"
            />
            <label class="user-label"> CPF Responsável</label>
          </div>
        </span>
        <span class="contentInputAccounting">
          <Input
            label="CRC Responsável"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.crc"
            :isDisabled="isDisabledInputs"
            maxlength="30"
            ref="crc"
          />
        </span>

        <span class="contentInputAccounting">
          <Input
            label="E-mail"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataAccounting.email"
            :isDisabled="isDisabledInputs"
            ref="email"
          />
        </span>
      </div>

      <div class="rowCustomContentBtsActions">
        <span style="width: 100px">
          <button
            size="sm"
            :class="`btnGeneral btnCustom ${isDisabledInputs && 'btnDisabled'}`"
            variant="none"
            @click="handleSaveOrUpdate"
          >
            <p>{{ dataAccounting.id ? "Atualizar" : "Salvar" }}</p>
          </button>
        </span>

        <span style="width: 100px">
          <button
            size="sm"
            class="btnGeneral"
            variant="none"
            @click="handleIsDisabledInputs"
          >
            <p>{{ isDisabledInputs ? "Editar" : "Cancelar" }}</p>
          </button>
        </span>
      </div>
    </div>

    <div class="customCard">
      <span class="title" style="justify-content: space-between">
        <span style="display: flex; gap: 5px; align-items: center">
          <b-icon-chat-text-fill class="icons" />
          <p>Mensagens e Documentos</p>
        </span>

        <div>
          <span style="width: 200px">
            <button
              size="sm"
              :class="`btnGeneral ${!dataAccounting.id && 'btnDisabled'}`"
              variant="none"
              @click="openModals('modalSendMessage')"
            >
              <p>Nova Solicitação</p>
            </button>
          </span>
        </div>
      </span>

      <div class="contentTable">
        <table>
          <thead
            style="
              color: whitesmoke;
              background: #3a4750;
              text-align: center;
              height: 29px;
            "
          >
            <tr style="width: 100%">
              <th>Data</th>
              <th>Assunto</th>
              <th>Solicitante</th>
              <th>Departamento</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody v-if="solicitations.length">
            <tr
              class="trCustom"
              v-for="solicitation in solicitations"
              :key="solicitation.id"
              style="text-align: center; height: 28px; cursor: context-menu"
            >
              <td>
                {{
                  solicitation.data.split(" ")[0].split("-").reverse().join("/")
                }}
              </td>
              <td>{{ solicitation.assunto }}</td>
              <td>{{ solicitation.solicitante }}</td>
              <td>{{ solicitation.departamento }}</td>
              <td>{{ solicitation.status }}</td>

              <td>
                <div class="btnActions">
                  <b-dropdown
                    id="dropdown-1"
                    text="Ações"
                    menu-class="w-1"
                    class="btnActions"
                    size="sm"
                    variant="none"
                  >
                    <template #button-content>
                      <b-icon-gear-fill
                        class="contentActions"
                      ></b-icon-gear-fill>
                    </template>
                    <b-dropdown-item
                      @click="deleteSolicitation(solicitation.id)"
                    >
                      Excluir
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="handleFindConversations(solicitation.id)"
                    >
                      Conversas
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr colspan="5">
              <div class="defaultSearch">
                <span>Não há dados para exibir ...</span>
              </div>
            </tr>
          </tbody>
        </table>

        <div class="setBtn">
          <button @click="previousPage" :disabled="page === 1" class="itemBtn">
            <b-icon-chevron-left></b-icon-chevron-left>
          </button>
          <button class="centerItemBtn">{{ page }}</button>
          <button v-if="solicitations.length" @click="nextPage" class="itemBtn">
            <b-icon-chevron-right></b-icon-chevron-right>
          </button>
        </div>
      </div>
    </div>

    <div class="customCard">
      <span class="title">
        <b-icon-cloud-arrow-down-fill class="icons" />
        <p>Relatórios</p>
      </span>

      <div class="rowCustom">
        <span class="contentInputReports">
          <Input
            label="Data inicial"
            type="date"
            :labelFixed="true"
            :dataInput.sync="dataReport.data_inicio"
          />
        </span>

        <span class="contentInputReports">
          <Input
            label="Data final"
            type="date"
            :labelFixed="true"
            :dataInput.sync="dataReport.data_final"
          />
        </span>

        <span class="contentInputReports">
          <InputSelect
            label="Modelo do documento"
            :enableIconCreate="false"
            colorBackground="#ffffff"
            :items="typeDocument"
            valueField="value"
            textField="text"
            :dataSelect.sync="dataReport.modelo"
          />
        </span>

        <span class="contentInputReports">
          <InputSelect
            label="Situação do documento"
            :enableIconCreate="false"
            colorBackground="#ffffff"
            :items="situationDocument"
            valueField="value"
            textField="text"
            :dataSelect.sync="dataReport.status"
          />
        </span>

        <!-- <span class="contentInputReports">
          <InputSelect
            label="Tipo do relatório"
            :enableIconCreate="false"
            colorBackground="#ffffff"
            :items="typeReport"
            valueField="value"
            textField="text"
            :dataSelect.sync="dataReport.relatorio"
          />
        </span> -->
      </div>

      <div style="display: flex; gap: 20px; margin-top: 0.5rem">
        <div>
          <button
            size="sm"
            class="btnGeneral"
            variant="none"
            :disabled="loadingToDownloadReports"
            @click="generateReport"
          >
            <p :style="`${loadingToDownloadReports && 'visibility: hidden;'}`">
              Gerar
            </p>

            <b-spinner class="spin" v-if="loadingToDownloadReports" />
          </button>
        </div>

        <div v-if="reportsItem.uuid && reportsItem.status === 'concluido'">
          <button
            size="sm"
            class="btnGeneral btnCustom"
            style="padding: 0; width: 30px; height: 30px"
            variant="none"
            @click="downloadReports"
            v-b-tooltip.hover.top="'Donwload'"
          >
            <b-icon-download style="color: white" scale="1.5" />
          </button>
        </div>
      </div>
    </div>

    <div class="customCard">
      <span class="title">
        <b-icon-file-text-fill class="icons" />
        <p>Sintegra</p>
      </span>

      <div class="rowCustom">
        <span class="contentInputReports">
          <Input
            label="Data inicial"
            type="date"
            :labelFixed="true"
            :dataInput.sync="dataToGenerateSintegra.startDate"
          />
        </span>

        <span class="contentInputReports">
          <Input
            label="Data final"
            type="date"
            :labelFixed="true"
            :dataInput.sync="dataToGenerateSintegra.endDate"
          />
        </span>

        <span class="contentInputReports">
          <Input
            label="Responsável"
            type="text"
            :labelFixed="true"
            :dataInput.sync="dataToGenerateSintegra.responsible"
          />
        </span>

        <span class="contentInputSintegra">
          <label for="isReg74" class="isReg74">
            <input
              id="isReg74"
              type="checkbox"
              v-model="dataToGenerateSintegra.includesReg74"
            />
            <p>Gerar registro 74 ?</p>
          </label>
        </span>

        <div>
          <button
            size="sm"
            class="btnGeneral"
            variant="none"
            @click="generateSintegra"
          >
            <p>Gerar</p>
          </button>
        </div>

        <div>
          <button
            size="sm"
            class="btnGeneral btnCustom"
            style="padding: 0; width: 30px; height: 30px"
            variant="none"
            @click="downloadSintegra"
            v-b-tooltip.hover.top="'Donwload'"
          >
            <b-icon-download style="color: white" scale="1.5" />
          </button>
        </div>
      </div>

      <div
        class="rowCustom"
        style="flex-direction: column"
        v-if="logsErrors.length"
      >
        <span class="conentTitleError">
          <p>* Erros encontrados, corrija-os e gere o sintegra novamente.</p>
        </span>

        <span class="conentError">
          <p v-for="(log, index) in logsErrors" :key="index">{{ log }}</p>
        </span>
      </div>
    </div>

    <div class="customCard">
      <span class="title">
        <b-icon-file-text-fill class="icons" />
        <p>SPED</p>
      </span>

      <div class="rowCustom">
        <span class="contentInputReports">
          <Input
            label="Data inicial"
            type="date"
            :labelFixed="true"
            :dataInput.sync="dataSped.startDate"
          />
        </span>

        <span class="contentInputReports">
          <Input
            label="Data final"
            type="date"
            :labelFixed="true"
            :dataInput.sync="dataSped.endDate"
          />
        </span>

        <div>
          <button
            size="sm"
            class="btnGeneral"
            variant="none"
            @click="handleGenerateSped"
          >
            <p>Gerar</p>
          </button>
        </div>

        <div v-if="spedStatus === 'FINALIZADO'">
          <button
            size="sm"
            class="btnGeneral btnCustom"
            style="padding: 0; width: 30px; height: 30px"
            variant="none"
            @click="downloadFile"
            v-b-tooltip.hover.top="'Donwload'"
          >
            <b-icon-download style="color: white" scale="1.5" />
          </button>
        </div>
        <div v-if="this.errosSped">
          <button
            size="sm"
            class="btnGeneral"
            variant="none"
            v-b-modal.modal-center3
          >
            <p>Exibir Erros</p>
          </button>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-center3"
      hide-footer
      hide-header
      centered
      size="lg"
      title="Excluir"
    >
      <div class="closeModalDetails" @click="$bvModal.hide('modal-center3')">
        X
      </div>
      <h6 class="titleModal" style="text-align: center">
        Erros do Arquivo do SPED
      </h6>
      <div
        style="
          max-height: 80vh;
          overflow: auto;
          display: flex;
          flex-direction: column;
          align-items: center;
        "
      >
        <div style="display: flex; flex-direction: column; font-size: 14px">
          <span v-for="(log, index) in errosSped" :key="index"
            >-{{ log.replace(",", "") }}</span
          >
        </div>
      </div>
    </b-modal>
    <ModalNewSolicitation
      :idAccounting="dataAccounting.id"
      @registeredNewSolicitation="findSolicitations"
    />

    <div :class="sizeModal">
      <div :class="modalContainerGeneral" v-if="colapseGeneral">
        <b-button class="closeModal" @click="handleModals"> X </b-button>
        <AccountingConversations
          v-if="enableModalAccountingConversation"
          :idSolicitation="idSolicitationSelected"
        />
      </div>
    </div>
    <b-toast id="my-toast" variant="secondary" solid>
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <b-icon-cloud-download-fill style="color: #ff5555" scale="1.5" />
          <strong style="padding-left: 10px">Atenção</strong>
        </div>
      </template>
      <span> O arquivo SPED está pronto para Download! </span>
      <span v-if="errosSped"> Porém, contém erros para serem corrigidos. </span>
    </b-toast>
  </section>
</template>

<script>
import api from "../../services/axios";
import { mapState, mapMutations } from "vuex";
import Input from "../UI/CustomInputs/Input.vue";
import InputCep from "../UI/CustomInputs/InputCep.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";
import InputCnpj from "../UI/CustomInputs/InputCnpj.vue";
import InputPhone from "../UI/CustomInputs/InputPhone.vue";
import ModalNewSolicitation from "./ModalNewSolicitation.vue";
import AccountingConversations from "./AccountingConversations.vue";

import ServiceNotaFiscal from "../../services/serviceNotaFiscal";
import ServiceAccounting from "../../services/serviceAccounting";
import ServiceAccountingSolicitations from "../../services/serviceAccountingSolicitations";
import ServiceAccountingMessages from "../../services/serviceAccountingMessages";
import ServiceAuxiliaresSintegra from "../../services/serviceAuxiliaresSintegra";
import ServiceSintegra from "../../services/serviceSintegra";
import ServiceSped from "../../services/serviceSped";

import { HandleErrors } from "../../utils/handleErrors";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { departaments } from "../../common/index";
import moment from "moment";

export default {
  components: {
    Input,
    InputCep,
    InputSelect,
    InputCnpj,
    InputPhone,
    ModalNewSolicitation,
    AccountingConversations,
  },
  data() {
    return {
      dataReport: {
        data_inicio: null,
        data_final: null,
        modelo: null,
        relatorio: null,
        status: null,
      },
      dataAccounting: {
        id: null,
        nome: null,
        cnpj: null,
        crc: null,
        responsavel: null,
        telefone: null,
        email: null,
        endereco: null,
        bairro: null,
        numero: null,
        cep: null,
        cpf: null,
      },
      dataToGenerateSintegra: {
        startDate: "",
        endDate: "",
        includesReg74: false,
        responsible: "",
      },
      typeDocument: [
        { text: "NF-e", value: "1" },
        { text: "NFC-e", value: "2" },
      ],
      typeReport: [
        { text: "CSV", value: "csv" },
        { text: "Excel", value: "excel" },
        { text: "Xml", value: "xml" },
        { text: "Danfe", value: "danfe" },
        { text: "Danfe Simples", value: "danfe_simples" },
        { text: "Danfe Etiqueta", value: "danfe_etiqueta" },
      ],
      situationDocument: [
        { text: "Emitidas", value: "Emitida" },
        { text: "Canceladas", value: "Cancelada" },
      ],
      isDisabledInputs: true,
      page: 1,
      solicitations: [],
      conversations: [],
      idSolicitationSelected: "",
      logsErrors: [],
      sintegraIsReady: { countLogs: 0, countSintegra: 0 },
      dataSped: {
        startDate: "",
        endDate: "",
      },
      intervalSpedId: null,
      spedStatus: null,
      errosSped: "",
      intervalReportsId: null,
      reportsItem: {
        uuid: null,
        status: null,
        url: null,
        dataExpiracao: null,
      },
      loadingToDownloadReports: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_ACCOUTING_CONVERSATIONS",
      "SET_ACCOUTING_NUMBER_NEW_MESSAGES",
      "SET_COLAPSE_GENERAL",
      "ALTER_SIZE_MODAL",
      "ALTER_MODAL_CONTAINER_GENERAL",
      "SET_OVERFLOW",
      "ALTER_TYPE_ACCOUNTING_CONVERSATION",
    ]),

    async saveAccounting() {
      try {
        const { id } = await ServiceAccounting.save(this.dataAccounting);
        this.dataAccounting.id = id;

        this.isDisabledInputs = true;
        this.$toast.open({
          message: "Contabilidade registrada com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        const typeError = HandleErrors(error?.response?.data?.message);

        if (
          typeError &&
          typeError?.nameError === TypeErrors.PLAN_WITHOUT_PERMISSION
        ) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message:
            `${error.response.data.erros || error.response.data.message}` ||
            "Ocorreu um erro ao salvar a contabilidade!",
          type: "info",
        });
      }
    },

    async updateAccounting() {
      try {
        await ServiceAccounting.update(
          this.dataAccounting,
          this.dataAccounting.id
        );

        this.isDisabledInputs = true;
        this.$toast.open({
          message: "Contabilidade atualizada com sucesso!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (
          typeError &&
          typeError?.nameError === TypeErrors.PLAN_WITHOUT_PERMISSION
        ) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message:
            `${error.response.data.erros || error.response.data.message}` ||
            "Ocorreu um erro ao atualizar a contabilidade!",
          type: "info",
        });
      }
    },

    async handleSaveOrUpdate() {
      if (this.isDisabledInputs) {
        return;
      }

      this.dataAccounting.id
        ? await this.updateAccounting()
        : await this.saveAccounting();
    },

    async findActivated() {
      const accounting = await ServiceAccounting.findActivated();
      return accounting;
    },

    async handleAccoutingAndRefs() {
      try {
        const accounting = await this.findActivated();
        Object.assign(this.dataAccounting, accounting);

        this.$refs.nome.valueInput = accounting.nome;
        this.$refs.cnpj.valueInput = accounting.cnpj;
        this.$refs.responsavel.valueInput = accounting.responsavel;
        this.$refs.telefone.valueInput = accounting.telefone;
        this.$refs.email.valueInput = accounting.email;
        this.$refs.crc.valueInput = accounting.crc;
        this.$refs.endereco.valueInput = accounting.endereco;
        this.$refs.bairro.valueInput = accounting.bairro;
        this.$refs.numero.valueInput = accounting.numero;
        this.$refs.cep.valueInput = accounting.cep;
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (
          typeError &&
          typeError?.nameError === TypeErrors.PLAN_WITHOUT_PERMISSION
        ) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        this.$toast.open({
          message:
            `${error.response.data.erros || error.response.data.message}` ||
            "Ocorreu um erro ao atualizar a contabilidade!",
          type: "info",
        });
      }
    },

    async generateReport() {
      try {
        this.loadingToDownloadReports = true;
        this.$toast.open({
          message: "Aguarde, seu download esta sendo processado...",
          type: "info",
        });

        await ServiceNotaFiscal.downloadInternalXml(this.dataReport);

        this.$toast.open({
          message: "Download Concluído",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Nenhum XML encontrado no periodo informado!",
          type: "info",
        });
      } finally {
        this.loadingToDownloadReports = false;
      }
    },

    async generateSintegra() {
      try {
        this.logsErrors = [];
        await ServiceAuxiliaresSintegra.generate(this.dataToGenerateSintegra);

        this.$toast.open({
          message: "Aguarde, o SINTEGRA esta sendo processado!",
          type: "info",
        });
      } catch (error) {
        this.$toast.open({
          message: `${
            error.response.data.message || "Ocorreu um erro gerar o sintegra"
          }`,
          type: "info",
        });
      }
    },

    async handleDownload() {
      await this.existsLogs();
      if (this.logsErrors) {
        return this.$toast.open({
          message: "Erros encontrados, corrija-os e gere novamente o SINTEGRA",
          type: "info",
        });
      }
    },

    async downloadSintegra() {
      try {
        const result = await ServiceSintegra.download();
        if (result) {
          this.logsErrors = result.split("!");
        }
      } catch (error) {
        this.$toast.open({
          message: error.message || "Ocorreu um erro ao buscar as conversas!",
          type: "info",
        });
      }
    },

    async existsLogs() {
      const logs = await ServiceSintegra.existsLogs();
      if (logs) {
        this.logsErrors = logs.split("!");
      }
    },

    async findSolicitations(page = 1) {
      const solicitations =
        await ServiceAccountingSolicitations.findPerPagination(page);

      this.solicitations = solicitations.map((solicitation) => {
        solicitation.departamento = departaments.find(
          (e) => e.value === solicitation.departamento
        ).text;

        return solicitation;
      });
    },

    async nextPage() {
      if (!this.solicitations.length) {
        return;
      }

      this.page += 1;
      await this.findSolicitations(this.page);
    },

    async previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.page -= 1;
        await this.findSolicitations(this.page);
      }
    },

    handleIsDisabledInputs() {
      this.isDisabledInputs = !this.isDisabledInputs;
    },

    async handleFindConversations(id) {
      try {
        const { messages, numberOfNewMessages } =
          await ServiceAccountingMessages.findByIdSolicitation(id);

        this.SET_ACCOUTING_CONVERSATIONS(messages.reverse());
        this.SET_ACCOUTING_NUMBER_NEW_MESSAGES(numberOfNewMessages);
        this.idSolicitationSelected = id;

        this.handleModals();
      } catch (error) {
        console.log(error);
        this.$toast.open({
          message: "Ocorreu um erro ao buscar as conversas!",
          type: "info",
        });
      }
    },

    async deleteSolicitation(id) {
      try {
        await ServiceAccountingSolicitations.delete(id);
        this.$toast.open({
          message: "Solicitação deletada com sucesso!",
          type: "sucess",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data.message ||
            "Ocorreu um erro ao buscar deletar!",
          type: "info",
        });
      }
    },

    async handleCep(cep) {
      try {
        const formatedCep = cep.replace(/\D/g, "");
        const { data } = await api.get(
          `https://brasilapi.com.br/api/cep/v1/${formatedCep}`
        );

        this.dataAccounting.bairro = data?.neighborhood || "";
        this.dataAccounting.endereco = data?.street || "";

        this.$refs.bairro.valueInput = data?.neighborhood || "";
        this.$refs.endereco.valueInput = data?.street || "";
      } catch (error) {
        this.$toast.open({
          message:
            "Ocorreu um erro ao buscar as informações , verifique o CEP e tente novamente",
          type: "info",
        });
      }
    },

    modalHeight() {
      this.overflow === "hidden"
        ? this.SET_OVERFLOW("auto")
        : this.SET_OVERFLOW("hidden");

      this.SET_COLAPSE_GENERAL(!this.colapseGeneral);

      this.colapseGeneral
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");

      this.modalContainerGeneral
        ? this.ALTER_MODAL_CONTAINER_GENERAL("modalContainer")
        : this.ALTER_MODAL_CONTAINER_GENERAL("contentModalDisable");
    },

    handleModals() {
      this.ALTER_TYPE_ACCOUNTING_CONVERSATION();

      this.modalHeight();
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    async handleGenerateSped() {
      for (const [key, value] of Object.entries(this.dataAccounting)) {
        if (!value) {
          this.$toast.error(
            `O campo "${key}" do Contador não pode estar vazio.`
          );
          return;
        }
      }
      const startDate = moment(this.dataSped.startDate, "YYYY-MM-DD");
      const endDate = moment(this.dataSped.endDate, "YYYY-MM-DD");

      if (
        startDate.month() !== endDate.month() ||
        startDate.year() !== endDate.year()
      ) {
        this.$toast.error("As datas devem pertencer ao mesmo mês e ano.");
        return;
      }

      await this.generateSped();
    },

    async generateSped() {
      try {
        await ServiceSped.generate(
          this.dataSped.startDate,
          this.dataSped.endDate
        );

        this.$toast.open({
          message: "Aguarde, o SPED esta sendo processado!",
          type: "info",
        });
        this.startCheckIfFinished();
      } catch (error) {
        this.$toast.open({
          message: `${
            error.response.data.message || "Ocorreu um erro gerar o sped"
          }`,
          type: "info",
        });
      }
    },

    async findSped() {
      try {
        const result = await ServiceSped.findSped();
        if (result) {
          if (result.status === "FINALIZADO") {
            this.clearIntervalSped();

            this.spedStatus = result.status;
            if (result.logs) {
              this.errosSped = result.logs.split("!");
            }
            if (!result.isDownload) {
              this.$bvToast.show("my-toast");
            }
          }
          return;
        }

        this.clearIntervalSped();
      } catch {
        this.$toast.open({
          message: "Ocorreu um problema ao gerar o SPED",
          type: "info",
        });

        this.clearIntervalSped();
      }
    },

    async downloadFile() {
      await ServiceSped.downloadFile();
    },

    startCheckIfFinished() {
      this.intervalSpedId = setInterval(() => {
        this.findSped();
      }, 10000);
    },

    clearIntervalSped() {
      clearInterval(this.intervalSpedId);
      this.intervalSpedId = null;
    },

    // async checkReportsIsComplete() {
    //   try {
    //     const result = await ServiceNotaFiscal.checkDownloadIsComplete();

    //     if (!result) this.clearIntervalReports();
    //     else this.reportsItem = result;
    //   } catch {
    //     this.$toast.open({
    //       message: "Ocorreu um problema ao gerar o SPED",
    //       type: "info",
    //     });

    //     this.clearIntervalReports();
    //   }
    // },

    downloadReports() {
      window.open(this.reportsItem.url, "_blank");
    },

    // startCheckReportsFinished() {
    //   this.intervalReportsId = setInterval(() => {
    //     this.checkReportsIsComplete();
    //   }, 10000);
    // },

    // clearIntervalReports() {
    //   clearInterval(this.intervalReportsId);
    //   this.intervalReportsId = null;
    // },
  },
  computed: {
    ...mapState({
      colapseGeneral: (state) => state.colapseGeneral,
      modalContainerGeneral: (state) => state.modalContainerGeneral,
      sizeModal: (state) => state.sizeModal,
      overflow: (state) => state.overflow,
      enableModalAccountingConversation: (state) =>
        state.enableModalAccountingConversation,
    }),
    maskTelefone() {
      return "(##) ####-####";
    },
    maskCpf() {
      return "###.###.###-##";
    },
  },
  mounted() {
    this.handleAccoutingAndRefs();
    this.findSolicitations(1);
    this.existsLogs();
    this.findSped();
    // this.checkReportsIsComplete();

    this.startCheckIfFinished();
    // this.startCheckReportsFinished();
  },
  beforeDestroy() {
    this.clearIntervalSped();
    // this.clearIntervalReports();
  },
};
</script>

<style scoped>
.containerGeralAccounting {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 2rem 2rem;
}

.customCard {
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 5px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 5px;
}

.title {
  width: 100%;
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: default;
  margin-top: 5px;
}

.title p {
  margin: 0;
  font-weight: 600;
  font-size: 13px;
  color: rgb(95, 95, 95);
}

.title .icons {
  color: rgb(95, 95, 95);
}

.isReg74 {
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: default;
  margin-top: 5px;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.inputDisabled {
  background-color: #fafafa;
  pointer-events: none;
  color: #949290 !important;
}

.closeModalDetails {
  width: 30px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 0px;
  color: red;
  border-radius: 2px;
  cursor: pointer;
  transition: ease-in all 0.2s;
  font-size: 18px;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.spin {
  color: white;
  width: 20px;
  height: 20px;
  position: absolute;
}

.isReg74 p {
  margin: 0;
  font-weight: 600;
  font-size: 12px;
  color: rgb(95, 95, 95);
}

.isReg74 .icons {
  color: rgb(95, 95, 95);
}

.rowCustom {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px 0 5px 0;
  margin-top: 1rem;
}

.rowCustomAccounting {
  display: flex;
  gap: 20px;
  padding: 10px 0 5px 0;
  margin-top: 1rem;
}

.rowCustomContentBtsActions {
  width: 100%;
  display: flex;
  gap: 20px;
  margin-top: 1rem;
}

.rowCustomSintegra {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  padding: 0px 0 5px 0;
  margin-top: 1rem;
}

.contentInputReports {
  width: 180px;
}

.contentInputSintegra {
  width: 140px;
}

.contentInputAccounting {
  width: 100%;
}

.btnGeneral {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  font-size: 12px;
  font-weight: normal;
  border: none;
  outline: none;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.179) !important;
  background-color: #5851a0;
  border-radius: 5px;
  transition: ease-in all 0.2s;
  cursor: pointer;
  padding-right: 0.8rem;
  padding-left: 0.8rem;
  position: relative;
}

.btnGeneral p {
  margin: 0;
  font-weight: normal;
  color: white;
}

.btnCustom {
  background-color: rgb(72, 184, 101);
}

.btnCustom:hover {
  background-color: rgb(59, 149, 83) !important;
  color: white;
}

.btnGeneral:hover {
  background-color: #322f5b;
  color: white;
}

.btnDisabled {
  background-color: gray;
  pointer-events: none;
}

.contentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  max-width: 100%;
  margin-top: 1rem;
  height: 330px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

table {
  width: 100%;
  height: 100%;
}

thead,
tbody {
  display: block;
}

tbody {
  overflow: auto;
  width: 100%;
  max-height: 250px;
  height: 100%;
  color: #3a4750;
}

th {
  font-weight: 500;
  font-size: 12px;
}

tr {
  display: flex;
  justify-content: space-between;
}

th,
td {
  padding: 5px;
  width: 20%;
}

td {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  font-size: 13px;
}

.trCustom > td:not(:last-child),
th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

span {
  cursor: default;
}

.btnActions {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.setBtn {
  display: flex;
  flex-direction: row;
  gap: 10px;
  bottom: 0;
  right: 0;
  padding: 0 0.5rem;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 30vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 50px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.closeModal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: transparent;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModal:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.conentTitleError p {
  margin: 0;
  font-size: 12px;
  color: red;
}

.conentError p {
  margin: 0;
  font-size: 12px;
  color: red;
}

@media screen and (max-width: 670px) {
  .contentInputReports {
    width: 100%;
  }
}
</style>